import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExpandableComponent } from '../../../common/expandable/expandable.component';
import { CommonModule } from '@angular/common';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';

@Component({
    standalone: true,
    imports: [CommonModule, HideUpComponent, ToggleModule],
    selector: 'filter-expandable',
    templateUrl: './filter-expandable.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterExpandableComponent extends ExpandableComponent {
    @Input()
    selectedOptionsQty?: number;

    @Input()
    selectedOptionsLabels?: string;

    get optionsLabels(): string {
        return this.selectedOptionsLabels?.replaceAll(',', ', ') || '';
    }
}
